import {
	CitizenshipStatusTypes,
  Products,
  ApplicationStatuses,
  StipulationStatuses,
  ProcessingCategories,
  SurveyQuestionTypes,
  IncomeSourceTypes,
  ApplicantTypes,
  ConsentTypes,
  AddressStates,
  AddressTypes,
  AddressCountries,
  StipulationTypesEnum,
  Programs,
  Flows,
  ConsentServiceEntityTypes,
	SchoolTypes,
} from "@/config/enums";

export class ImageConstants {
  public static get BACKGROUND_GRAD(): string {
    return "background-grad.png";
  }
  public static get APP_ARCHIVE(): string {
    return "app-archive-rev.png";
  }
  public static get APPLY_STUDENT_LOAN(): string {
    return "apply-student-loan-rev.png";
  }
  public static get FOOTER_LOGO(): string {
    return "footer-logo-cusc.png";
  }
  public static get MODAL_CLOSE(): string {
    return "modal-close.png";
  }
}

export class CitizenshipStatusTypeIds {
  public static get USCitizen(): number {
    return CitizenshipStatusTypes.USCitizen;
  }
  public static get PermanentResident(): number {
    return CitizenshipStatusTypes.PermanentResident;
  }
  public static get NonCitizen(): number {
    return CitizenshipStatusTypes.NonCitizen;
  }
  public static get NonUSCitizenWithSSN(): number {
    return CitizenshipStatusTypes.NonUSCitizenWithSSN;
  }
}

export class ConsentServiceEntityTypeIds {
  public static get Application(): number {
    return ConsentServiceEntityTypes.Application;
  }
  public static get Loan(): number {
    return ConsentServiceEntityTypes.Loan;
  }
  public static get Draw(): number {
    return ConsentServiceEntityTypes.Draw;
  }
}

export class EmailAddressConstants {
  public static get Privacy(): string {
    return "privacy@studentchoice.org";
  }

  public static get MemberSupport(): string {
    return "member_support@studentchoice.org";
  }
}

export class StipulationStatusIds {
  public static get OPEN(): number {
    return StipulationStatuses.OPEN;
  }

  public static get COMPLETED(): number {
    return StipulationStatuses.COMPLETED;
  }

  public static get CU_OVERRIDE(): number {
    return StipulationStatuses.CU_OVERRIDE;
  }

  public static get CANCELLED(): number {
    return StipulationStatuses.CANCELLED;
  }
  public static get PENDING(): number {
    return StipulationStatuses.PENDING;
  }
}

export class ProductIds {
  public static get LOC(): number {
    return Products.LOC;
  }
  public static get REFI(): number {
    return Products.REFI;
  }
  public static get PEL(): number {
    return Products.PEL;
  }
}

export class ApplicationStatusTypeIds {
  public static get NOT_SUBMITTED(): number {
    return ApplicationStatuses.NOT_SUBMITTED;
  }
  public static get EVALUATION(): number {
    return ApplicationStatuses.EVALUATION;
  }
  public static get SUBMITTED_AND_PROCESSING(): number {
    return ApplicationStatuses.SUBMITTED_AND_PROCESSING;
  }
  public static get COMPLETE(): number {
    return ApplicationStatuses.COMPLETE;
  }
  public static get DECLINED(): number {
    return ApplicationStatuses.DECLINED;
  }
  public static get CANCELLED(): number {
    return ApplicationStatuses.CANCELLED;
  }
  public static get SMR_DECLINED(): number {
    return ApplicationStatuses.SMR_DECLINED;
  }
  public static get RIGHT_TO_CANCEL(): number {
    return ApplicationStatuses.RIGHT_TO_CANCEL;
  }
  public static get SCHOOL_CERTIFICATION(): number {
    return ApplicationStatuses.SCHOOL_CERTIFICATION;
  }
}

export class DocumentNameConstants {
  public static get DESIGNATION_OF_AUTHORIZED_INDIVIDUAL_FORM(): string {
    return "Designation of Authorized Individual (Optional election)";
  }
}

export class PayoffVerificationStipulationTypeIds {
  public static get ConfirmPayoffRequest(): number {
    return StipulationTypesEnum.ConfirmPayoffRequest;
  }
  public static get LoanAccountStatement(): number {
    return StipulationTypesEnum.LoanAccountStatement;
  }
  public static get PayoffStatement(): number {
    return StipulationTypesEnum.PayoffStatement;
  }
  public static get LoanResponsibilityAffidavit(): number {
    return StipulationTypesEnum.LoanResponsibilityAffidavit;
  }
  public static get ResponsibilityForUnderPayment(): number {
    return StipulationTypesEnum.ResponsibilityForUnderPayment;
  }
  public static get ServicerPayoffAddress(): number {
    return StipulationTypesEnum.ServicerPayoffAddress;
  }
}

export class IncomeStipulationTypeIds {
  public static get OtherIncome(): number {
    return StipulationTypesEnum.OtherIncome;
  }
  public static get AutomatedIncomeVerificationConsent(): number {
    return StipulationTypesEnum.AutomatedIncomeVerificationConsent;
  }
  public static get IncomeVerification(): number {
    return StipulationTypesEnum.IncomeVerification;
  }
  public static get NonIncomeResponsibleApplicant(): number {
    return StipulationTypesEnum.NonIncomeResponsibleApplicant;
  }
}

export class IdentityStipulationTypeIds {
  // only visible to assigned applicant
  public static get NameVerification(): number {
    return StipulationTypesEnum.NameVerification;
  }
  public static get AddressVerification(): number {
    return StipulationTypesEnum.AddressVerification;
  }
  public static get DateOfBirthVerification(): number {
    return StipulationTypesEnum.DateOfBirthVerification;
  }
  public static get SSNVerification(): number {
    return StipulationTypesEnum.SSNVerification;
  }

  // Visible to all applicants
  public static get ITINLetterOrCard(): number {
    return StipulationTypesEnum.ITINLetterOrCard;
  }
}

export class ProcessingCategoryIds {
  public static get Income(): number {
    return ProcessingCategories.Income;
  }
  public static get Citizenship(): number {
    return ProcessingCategories.Citizenship;
  }
  public static get Membership(): number {
    return ProcessingCategories.Membership;
  }
  public static get Identity(): number {
    return ProcessingCategories.Identity;
  }
  public static get SpousalConsent(): number {
    return ProcessingCategories.SpousalConsent;
  }
  public static get FinalReview(): number {
    return ProcessingCategories.FinalReview;
  }
  public static get LoanConfiguration(): number {
    return ProcessingCategories.LoanConfiguration;
  }
  public static get ESign(): number {
    return ProcessingCategories.ESign;
  }
  public static get Credit(): number {
    return ProcessingCategories.Credit;
  }
  public static get Misc(): number {
    return ProcessingCategories.Misc;
  }
  public static get PayoffVerification(): number {
    return ProcessingCategories.PayoffVerification;
  }
  public static get EligibilityVerification(): number {
    return ProcessingCategories.EligibilityVerification;
  }
  public static get RateTerm(): number {
    return ProcessingCategories.RateTerm;
  }
  public static get Employment(): number {
    return ProcessingCategories.Employment;
  }
  public static get Regulatory(): number {
    return ProcessingCategories.Regulatory;
  }
}

export class SurveyQuestionTypeIds {
  public static get TwoYearsIncome(): number {
    return SurveyQuestionTypes.TwoYearsIncome;
  }
  public static get SelectedCreditRange(): number {
    return SurveyQuestionTypes.SelectedCreditRange;
  }
  public static get MaritalStatus(): number {
    return SurveyQuestionTypes.MaritalStatus;
  }
  public static get SMREstimateLoanAmount(): number {
    return SurveyQuestionTypes.SMREstimateLoanAmount;
  }
  public static get EmploymentStatus(): number {
    return SurveyQuestionTypes.EmploymentStatus;
  }
  public static get EmployerName(): number {
    return SurveyQuestionTypes.EmployerName;
  }
}

export class IncomeSourceTypeIds {
  public static get PAYCHECK_FROM_EMPLOYER(): number {
    return IncomeSourceTypes.PAYSTUB;
  }
  public static get INCOME_FROM_BUSINESS_YOU_OWN(): number {
    return IncomeSourceTypes.SCHEDULE_C;
  }
  public static get SOCIAL_SECURITY_BENEFITS(): number {
    return IncomeSourceTypes.SOCIAL_SECURITY_BENEFITS;
  }
  public static get RETIREMENT(): number {
    return IncomeSourceTypes.RETIREMENT;
  }
  public static get INCOME_FROM_RENTAL_OR_INVESTMENT_PROPERTY(): number {
    return IncomeSourceTypes.SCHEDULE_E;
  }
  public static get OTHER_INCOME(): number {
    return IncomeSourceTypes.OTHER_INCOME;
  }
}

export class ApplicantTypeIds {
  public static get PRIMARY_APPLICANT(): number {
    return ApplicantTypes.PRIMARY_APPLICANT;
  }

  public static get CO_APPLICANT(): number {
    return ApplicantTypes.CO_APPLICANT;
  }
}

export class ConsentTypeIds {
  public static get CREDIT(): number {
    return ConsentTypes.CREDIT;
  }

  public static get ECOMMUNICATION(): number {
    return ConsentTypes.ECOMMUNICATION;
  }

  public static get MOBILE(): number {
    return ConsentTypes.MOBILE;
  }

  public static get TERMS_AND_CONDITIONS(): number {
    return ConsentTypes.TERMS_AND_CONDITIONS;
  }

  public static get EMAIL_VALIDATION(): number {
    return ConsentTypes.EMAIL_VALIDATION;
  }

  public static get SOFT_PULL(): number {
    return ConsentTypes.SOFT_PULL;
  }

  public static get REFI_UNDERPAYMENT(): number {
    return ConsentTypes.REFI_UNDERPAYMENT;
  }

  public static get SLR_PAYOFF_CONFIRMATION(): number {
    return ConsentTypes.SLR_PAYOFF_CONFIRMATION;
  }

  public static get CONFIRMATION_OF_LOAN_TERMS(): number {
    return ConsentTypes.CONFIRMATION_OF_LOAN_TERMS;
  }
	
  public static get PARENT_ATTESTATION(): number {
    return ConsentTypes.PARENT_ATTESTATION;
  }
}

export class RateTypeNames {
  public static get FIXED(): string {
    return "Fixed";
  }
  public static get VARIABLE(): string {
    return "Variable";
  }
}

export class RateTypeIds {
  public static get FIXED(): number {
    return 1;
  }
  public static get VARIABLE(): number {
    return 2;
  }
}

export class EsignStipulationTypeIds {
  public static get ConfirmationEsign(): number {
    return StipulationTypesEnum.ConfirmationEsign;
  }
  public static get ExecuteLegalDocPackage(): number {
    return StipulationTypesEnum.ExecuteLegalDocPackage;
  }
}

export class RegulatoryStipulationTypeIds {
  public static get SelfCertificationDetails(): number {
    return StipulationTypesEnum.SelfCertificationDetails;
  }
}

export class AddressStateIds {
  public static get CALIFORNIA(): number {
    return AddressStates.CALIFORNIA;
  }
}
export class AddressCountryIds {
  public static get USA(): number {
    return AddressCountries.USA;
  }
}
export class AddressTypeIds {
  public static get PermanentAddress(): number {
    return AddressTypes.PermanentAddress;
  }
  public static get PreviousAddress(): number {
    return AddressTypes.PreviousAddress;
  }
}

export class CreditStipulationTypeIds {
  // Visible to all applicants
  public static get ADDMismatch(): number {
    return StipulationTypesEnum.ADDMismatch;
  }
  public static get SSNMistmatchProofSSN(): number {
    return StipulationTypesEnum.SSNMistmatchProofSSN;
  }

  // Visible to applicant only
  public static get UnfreezeCredit(): number {
    return StipulationTypesEnum.UnfreezeCredit;
  }
  public static get UnSuppressBureau(): number {
    return StipulationTypesEnum.UnSuppressBureau;
  }
  public static get ContactCBRCorrection(): number {
    return StipulationTypesEnum.ContactCBRCorrection;
  }
}

export class MembershipStipulationTypeIds {
  public static get EstablishMembership(): number {
    return StipulationTypesEnum.EstablishMembership;
  }
  public static get MaintainMembership(): number {
    return StipulationTypesEnum.MaintainMembership;
  }
}

export const ASSIGNED_APPLICANT_ONLY = [
  RegulatoryStipulationTypeIds.SelfCertificationDetails,
  EsignStipulationTypeIds.ExecuteLegalDocPackage,
  EsignStipulationTypeIds.ConfirmationEsign,
  PayoffVerificationStipulationTypeIds.LoanResponsibilityAffidavit,
  PayoffVerificationStipulationTypeIds.ResponsibilityForUnderPayment,
  IdentityStipulationTypeIds.NameVerification,
  IdentityStipulationTypeIds.AddressVerification,
  IdentityStipulationTypeIds.DateOfBirthVerification,
  IdentityStipulationTypeIds.SSNVerification,
  CreditStipulationTypeIds.UnfreezeCredit,
  CreditStipulationTypeIds.UnSuppressBureau,
  CreditStipulationTypeIds.ContactCBRCorrection,
  IncomeStipulationTypeIds.AutomatedIncomeVerificationConsent,
  IncomeStipulationTypeIds.IncomeVerification,
  IncomeStipulationTypeIds.NonIncomeResponsibleApplicant,
];

export const ugPrograms: Readonly<number[]> = [Programs.UNDERGRADUATE];

export const CustomSchoolTypes: Readonly<number[]> = [SchoolTypes.AVIATION];

export const professionalGradFlowsDictionary: Readonly<Record<number, number[]>> = {
  [Flows.STRICT]: [Programs.DOMESTIC_GRADUATE, Programs.DOMESTIC_GRADUATE2],
  [Flows.MDDO]: [
    Programs.MEDICAL,
    Programs.MEDICAL2,
    Programs.MEDICAL3,
    Programs.MEDICAL_OSTEOPATHIC,
    Programs.MEDICAL_OSTEOPATHIC2,
    Programs.MEDICAL_OSTEOPATHIC3,
    Programs.MEDICAL_AND_OSTEOPATHIC,
    Programs.MEDICAL_AND_OSTEOPATHIC2,
    Programs.MEDICAL_AND_OSTEOPATHIC3,
  ],
  [Flows.MEDICAL]: [
    Programs.DENTAL,
    Programs.DENTAL2,
    Programs.DENTAL3,
    Programs.PODIATRY,
    Programs.PODIATRY2,
    Programs.PODIATRY3,
    Programs.OPTOMETRY,
    Programs.OPTOMETRY2,
    Programs.OPTOMETRY3,
    Programs.VETERINARY_MEDICINE,
    Programs.VETERINARY_MEDICINE2,
    Programs.VETERINARY_MEDICINE3,
    Programs.HEALTH_PROFESSIONS,
    Programs.HEALTH_PROFESSIONS2,
    Programs.HEALTH_PROFESSIONS3,
  ],
  [Flows.PROF]: [
    Programs.LAW,
    Programs.LAW2,
    Programs.LAW3,
    Programs.THEOLOGY,
    Programs.THEOLOGY2,
    Programs.THEOLOGY3,
    Programs.PHARMACY,
    Programs.PHARMACY2,
    Programs.PHARMACY3,
    Programs.CLINICAL_PSYCHOLOGY,
    Programs.CLINICAL_PSYCHOLOGY2,
    Programs.CLINICAL_PSYCHOLOGY3,
    Programs.ADVANCED_DEGREE,
    Programs.ADVANCED_DEGREE2,
    Programs.ADVANCED_DEGREE3,
  ],
};

